import { useTheme } from '@mui/material';

export const NewCompensationIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg width={40} height={40} fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#a)">
                <path
                    d="M41.454 28.132a2.774 2.774 0 0 1-.59 3.881l-8.79 6.479a9.452 9.452 0 0 1-5.604 1.84H4.222A2.22 2.22 0 0 1 2 38.11v-4.444a2.22 2.22 0 0 1 2.222-2.222h2.555l3.118-2.5A8.87 8.87 0 0 1 15.45 27h10.992a2.22 2.22 0 0 1 2.222 2.222 2.22 2.22 0 0 1-2.222 2.222h-5.555c-.611 0-1.111.5-1.111 1.111s.5 1.111 1.111 1.111h8.374l8.312-6.124a2.774 2.774 0 0 1 3.881.59Z"
                    fill={primaryBackground}
                />
                <path
                    d="m38.42 29.41-8.79 6.478a8.702 8.702 0 0 1-5.16 1.694H2.222A1.47 1.47 0 0 1 .75 36.11v-4.444a1.47 1.47 0 0 1 1.472-1.472h2.819l.205-.165 3.118-2.5a8.12 8.12 0 0 1 5.086-1.779h10.992a1.47 1.47 0 0 1 1.472 1.472 1.47 1.47 0 0 1-1.472 1.472h-5.555a1.864 1.864 0 0 0-1.861 1.861c0 1.025.836 1.861 1.861 1.861h8.621l.198-.146 8.311-6.124a2.025 2.025 0 0 1 2.833.43 2.024 2.024 0 0 1-.43 2.833Z"
                    stroke={primaryStroke}
                    strokeWidth={1.5}
                />
                <path
                    d="M22.053 20.38v-1.846a12.757 12.757 0 0 1-1.934-.176c-.61-.106-1.107-.243-1.494-.413V16.52c.404.187.923.351 1.556.492.633.14 1.256.217 1.872.228v-3.867c-.774-.216-1.415-.463-1.925-.738-.504-.281-.882-.624-1.134-1.028-.252-.405-.378-.894-.378-1.468 0-.598.14-1.107.422-1.53.287-.427.689-.761 1.204-1.001.516-.24 1.12-.378 1.81-.413v-1.52h1.073v1.502a8.411 8.411 0 0 1 1.714.211c.516.117.993.27 1.433.457l-.457 1.222a9.556 9.556 0 0 0-1.293-.405 9.514 9.514 0 0 0-1.397-.228v3.84c.785.23 1.441.472 1.969.73.533.258.934.577 1.204.958.27.381.404.873.404 1.477 0 .855-.313 1.547-.94 2.074-.627.521-1.506.838-2.637.95v1.915h-1.072Zm1.072-3.218c.72-.07 1.257-.243 1.608-.518.358-.281.537-.65.537-1.107 0-.329-.07-.598-.211-.81-.135-.21-.358-.392-.668-.544-.31-.158-.733-.308-1.266-.448v3.427Zm-1.072-5.255V8.47c-.44.03-.809.111-1.108.246-.299.135-.524.31-.676.527-.147.217-.22.475-.22.774 0 .346.064.636.193.87.135.229.349.425.642.589.299.158.688.302 1.169.43Z"
                    fill={primaryStroke}
                />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M0 0h40v40H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
